import { useEffect } from 'react'
import { CFA_INFO, SITE_URL } from '../data/constants'

type SeoOptions = {
  /** Titre de la page, sans le nom du site (ajouté automatiquement) */
  title: string
  /** Description affichée dans les résultats Google (150-160 caractères idéalement) */
  description: string
  /** Chemin de la page, ex. "/formations" — sert à l'URL canonique */
  path: string
}

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  )
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

/**
 * Renseigne le titre et les métadonnées de la page courante.
 * Indispensable pour être correctement référencé sur Google :
 * chaque page doit avoir un titre et une description uniques.
 */
export function useSeo({ title, description, path }: SeoOptions) {
  useEffect(() => {
    const fullTitle = `${title} | ${CFA_INFO.name}`
    const url = `${SITE_URL}${path}`

    document.title = fullTitle
    document.documentElement.lang = 'fr'

    setMeta('name', 'description', description)
    setMeta('name', 'robots', 'index, follow')
    setMeta('property', 'og:type', 'website')
    setMeta('property', 'og:site_name', CFA_INFO.name)
    setMeta('property', 'og:locale', 'fr_FR')
    setMeta('property', 'og:title', fullTitle)
    setMeta('property', 'og:description', description)
    setMeta('property', 'og:url', url)
    setMeta('name', 'twitter:card', 'summary_large_image')
    setMeta('name', 'twitter:title', fullTitle)
    setMeta('name', 'twitter:description', description)
    setCanonical(url)
  }, [title, description, path])
}
